import * as React from 'react';
import type { SVGProps } from 'react';

const SvgInterestIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="none" {...props}>
    <path
      fill="#222426"
      fillRule="evenodd"
      d="M20.412 4.791a2.64 2.64 0 0 0-1.912-.833h-2.3v-.853c0-.608-.23-1.193-.64-1.626A2.15 2.15 0 0 0 14 .8H3.5a2.64 2.64 0 0 0-1.913.833A2.904 2.904 0 0 0 .8 3.632v14.736c0 .748.282 1.467.787 1.999A2.64 2.64 0 0 0 3.5 21.2h15a2.64 2.64 0 0 0 1.913-.833c.505-.532.787-1.251.787-1.999V6.79c0-.748-.282-1.467-.788-1.999Zm-4.998-3.175c.375.395.586.93.586 1.49v1.052-1.053c0-.558-.21-1.094-.586-1.489ZM1.711 20.206l.021.023ZM3.5 21h15a2.44 2.44 0 0 0 1.767-.771 2.705 2.705 0 0 0 .733-1.86V6.788v11.58c0 .697-.264 1.366-.733 1.86A2.44 2.44 0 0 1 18.5 21h-15ZM14.69 2.346a.977.977 0 0 0-.69-.293H3.5a1.467 1.467 0 0 0-1.06.464c-.28.296-.439.696-.44 1.115v14.737V3.632c.001-.419.16-.82.44-1.115a1.467 1.467 0 0 1 1.06-.464H14c.258 0 .505.106.69.293ZM2.859 19.55c-.399-.24-.652-.69-.658-1.183V3.632c.001-.369.14-.72.386-.977.244-.258.573-.4.914-.402H14c.208 0 .41.088.561.247.152.16.238.377.24.606v.852H8c-.852 0-1.667.357-2.266.988a3.447 3.447 0 0 0-.934 2.37v11.051a1.395 1.395 0 0 1-.658 1.183c-.398.24-.886.24-1.284 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M13 9.657c2.22-2.281 7.767 1.71 0 6.843-7.767-5.132-2.219-9.124 0-6.843Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInterestIcon;
